import React from "react";
import FileUploadControl from "../../utils/form/FileUploadControl";
import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  FormSubmitButton,
  SelectControl,
} from "../../utils/form";

import { Row, Col } from "react-bootstrap";
import { ClearButton, CustomModal, ImageUploader } from "../common";
import { addeventOrganiserApi, updateeventOrganiserApi } from "./Api";
import { getAdminUser, getSafeArray } from "../../utils/ReusableFunctions";
import { getAllSsoPartnersApi } from "../sso/Api";
import { publishOptions } from "../../utils/Constant";


class EventOrganiserForm extends BaseReactComponent {
  constructor(props) {
    super(props);
    const data = props.editData || null;
    let partners = this.loadDefaultPartners()
     if(data){
      
    }
    this.state = {
      eventOrganiserName: data?.eventOrganiserName || "",
      description: data?.description || "",
      thumbnailPath: "",
      thumbnailFile: null,
      bannerPath: "",
      bannerfile: null,
      uploadImage: data?.thumbnailPath || null,
      uploadImage2: data?.bannerPath || null,
      attachments: [],
    };
  }
  imageUploaser = (e, name) => {

    const imageUrl = URL.createObjectURL(e.target.files[0]);
    if (name === "banner") {
      this.setState({ bannerPath: e.target.files[0].name, bannerfile: e.target.files[0], uploadImage2: imageUrl })

    } else {
      this.setState({ thumbnailPath: e.target.files[0].name, thumbnailFile: e.target.files[0], uploadImage: imageUrl })
    }
  }

  componentDidMount() { 
    getAllSsoPartnersApi(this)
  }
  onValidSubmit = () => {
    let eventData = {
      "data": {
        "eventOrganiserName": this.state.eventOrganiserName,
        "description": this.state.description,
        ...(this.state.thumbnailPath ? { "thumbnailPath": this.state.thumbnailPath } : {}),
        ...(this.state.bannerPath ? { "bannerPath": this.state.bannerPath } : {}),

      }
    }
     if(this.state.publishTo.length > 0){
      eventData.data.isVisibleOnTfp = this.state.publishTo?.includes("isVisibleOnTfp");
      if(eventData.data.isVisibleOnTfp){
        eventData.data.ssoPartners = getAdminUser()?.ssoPartner? getAdminUser().ssoPartner?.uuid : this.state.ssoPartners?.join(',');
      }else{
        eventData.data.ssoPartners = "";
      }
    }
    const data = new FormData();
    data.append("key", JSON.stringify(eventData));
    if (this.state.thumbnailFile) {
      data.append("file", this.state.thumbnailFile);
    }
    if (this.state.bannerfile) {
      data.append("file", this.state.bannerfile);
    }

    if (this.props.editData) {
      updateeventOrganiserApi(data, this.props.this, this.props.onHide, this.props.editData.uuid)
    } else {
      addeventOrganiserApi(data, this.props.this, this.props.onHide);
    }
  };
  render() {
    const { uploadImage, thumbnailFile, bannerfile, uploadImage2 } = this.state;
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={this.props?.editData?.uuid ? "Edit Event Organizer" : "Add Event Organizer"}
        modalClass={"change-password"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          <Row>
                <Col md={6}>
                      <FormElement
                        valueLink={this.linkState(this, "publishTo")}
                        label="Publish To"
                        required
                        validations={[
                          {
                            validate: FormValidator.isRequired,
                            message: "Publish To cannot be empty",
                          },
                        ]}
                        control={{
                          type: SelectControl,
                          settings: {
                            options: publishOptions,
                            placeholder: "Select Publish To",
                            multiple: true,
                            searchable: false,
                            onChangeCallback: (onBlur) => {
                              onBlur(this.state.publishTo);
                            },
                          },
                        }}
                      />
                      {this.state.publishTo?.length > 0 &&
                        <ClearButton onClick={() => this.setState({ publishTo: [] })} />
                      }
                    </Col>
                    {
                      this.state.publishTo?.includes("ssoPartners") && !getAdminUser()?.ssoPartner &&
                      <Col md={6}>
                        <FormElement
                          valueLink={this.linkState(this, "ssoPartners")}
                          label="Select Partners"
                          required
                          validations={[
                            {
                              validate: FormValidator.isRequired,
                              message: "Partners cannot be empty",
                            },
                          ]}
                          control={{
                            type: SelectControl,
                            settings: {
                              options: this.state?.ssoPartnersOptions || [],
                              placeholder: "Select Partners",
                              multiple: true,
                              searchable: true,
                              selectAll: true,
                              onChangeCallback: (onBlur) => {
                                onBlur(this.state.ssoPartners);
                              },
                            },
                          }}
                        />
                      </Col>

                    }
            <Col sm={12}>
              <FormElement
                valueLink={this.linkState(this, "eventOrganiserName")}
                label="Event Organizer Name"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    placeholder: "Enter Name",
                  },
                }}
              />
            </Col>
            <Col sm={12}>
              <FormElement
                valueLink={this.linkState(this, "description")}
                label="Description"
                helpText="Description can't be more than 4000 character"

                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    as: "textarea",
                    placeholder: "Enter Description",
                  },
                }}
              />
            </Col>
            <Col sm={6}>
              <ImageUploader required={true} id="Thumbnail" label="Upload Thumbnail" name={typeof (thumbnailFile) == 'object' ? uploadImage : thumbnailFile} onChange={(e) => this.imageUploaser(e, "thumbnail")} onDelete={() => this.setState({ thumbnailFile: "" })} />
            </Col>
            <Col sm={6}>
              <ImageUploader required={true} id="Banner" label="Upload Banner" name={typeof (bannerfile) == 'object' ? uploadImage2 : bannerfile} onChange={(e) => this.imageUploaser(e, "banner")} onDelete={() => this.setState({ bannerfile: "" })} />
            </Col>
          </Row>

          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              Save
            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

export default EventOrganiserForm;
